const MenuCloseSvg = ({
  height = 24,
  width = 24,
  viewBox = '0 0 24 24',
  stroke = 'white',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  stroke?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MenuCloseSvg;
